function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "stack");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "stack",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Archive-Type-2",
  transform: "translate(1.000000, 7.000000)"
}, React.createElement("path", {
  d: "M30.7101213,26 C29.8495721,28.8914889 27.1710206,31 24,31 C20.8289794,31 18.1504279,28.8914889 17.2898787,26 L2,26 L2,36 L46,36 L46,26 L30.7101213,26 Z",
  id: "Combined-Shape",
  stroke: "currentColor",
  strokeWidth: 4
}), React.createElement("rect", {
  id: "Rectangle",
  fill: "currentColor",
  fillRule: "nonzero",
  x: 0,
  y: 16,
  width: 48,
  height: 4,
  rx: 2
}), React.createElement("rect", {
  id: "Rectangle-Copy-25",
  fill: "currentColor",
  fillRule: "nonzero",
  x: 0,
  y: 8,
  width: 48,
  height: 4,
  rx: 2
}), React.createElement("rect", {
  id: "Rectangle-Copy-26",
  fill: "currentColor",
  fillRule: "nonzero",
  x: 0,
  y: 0,
  width: 48,
  height: 4,
  rx: 2
})));

var SvgStack = function SvgStack(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgStack, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/stack.3f47a603.svg";
export { ForwardRef as ReactComponent };